(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiMyTrainingExterior', taiMyTrainingExterior);

    function taiMyTrainingExterior() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingExteriorController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.exterior.html',
            scope: {
                isFocus: '=',
                translatePool: '=',
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingExteriorController(trainingInnerService, $uibModal, $q,
        modalService, $rootScope, $scope) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.translatePool = $scope.$parent.vm.data.translatePool;
        //===Main===
        onInit();
        //==========
        function onInit() {
            //===
            vm.mustRemark = false;
            vm.submit = submit;
            vm.openOrganizer = openOrganizer;
            vm.removeOrganizer = removeOrganizer;
            vm.removeTime = removeTime;
            vm.openTime = openTime;
            vm.plusTotalPricer = plusTotalPricer;
            vm.openApplicationFormTypeSelector = openApplicationFormTypeSelector;
            vm.method = methodList(); //有一天要把上面這些設定移到這裡
            vm.isMobile=modalService.isMobile();
            //===
            vm.applicationForm = applicationFormInit();
            vm.data = dataInit();
            vm.view = viewInit();
            vm.UserAccount = $rootScope.userInfo.userAccount;
            //===
            $scope.$watch('vm.isFocus', function(newValue) {
                if (newValue === true && vm.view.isInited === false) {
                    logicInit();
                }
            });

        }

        function logicInit() {
            vm.view.isInited = true;
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //=====
            var exteriorData = trainingInnerService.getExterior();
            var Externaltype = trainingInnerService.getExternaltype();
            //console.log('Externaltype:',Externaltype);
            var currency = trainingInnerService.getCurrency();
            $q.all([exteriorData, Externaltype, currency])
                .then(function(data) {
                    // 皆需排除掉第一筆資料: ALL - 1

                    vm.data.exteriorData = _.filter(data[0], function(o) {
                        return o.id !== -1;
                    });
                    // vm.data.type = _.filter(data[1], function(o) {
                    //     return o.id !== -1;
                    // });
                    vm.data.type = data[1][0];
                    vm.data.currency = _.filter(data[2], function(o) {
                        return o.id !== -1;
                    });

                    // 設置預設選取第一個 radio btn
                    vm.applicationForm.currency = _.head(vm.data.currency).id;
                })
                .then(function() {
                    vm.view.pageLoaded = true;
                    vm.view.pageLoading = false;
                });
        }

        function methodList() {
            var result = {

            };
            return result;
        }

        function viewInit() {
            var result = {
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false, //.........頁面讀取中
            };
            return result;
        }

        function dataInit() {
            var result = {
                organizer: [],
                exteriorData: null,
                type: null,
                currency: null,
                dateSettingList: [],
                organizerOther: 413,
            };
            return result;
        }

        function applicationFormInit() {
            var result = {
                Name: null,
                type: null,
                Outline: null,
                Place: null,
                currency: null,
                organizer: [],
                times: null,
                dateSettingList: [],
                Remark: '',
                coursePrice: 0,
                travelPrice: 0,
                totalPrice: 0,
                allowance: 0,
            };
            return result;
        }

        function submit() {
            if (vm.mustRemark && !vm.applicationForm.Remark) {
                vm.form1.$valid = false;
            }
            if (vm.form1.$valid === false) {
                toastr.warning(vm.translatePool.tsunFormMsgRequiredEmpty);
                return;
            }

            if (vm.data.organizer !== null) {
                vm.applicationForm.organizer = vm.data.organizer;
            }
            vm.applicationForm.dateSettingList = angular.copy(vm.data.dateSettingList);
            //======
            var exteriorType = angular.copy(vm.applicationForm.type) || {};
            var isAllowance = (exteriorType.allowanceRate > 0);
            var isFeeEmpty = vm.applicationForm.totalPrice < 1;
            //=====
            if (isAllowance && isFeeEmpty) {
                //TODO:多國語系(英文)
                var errorMsgEmptyFee = format(
                    vm.translatePool.tsunErrorExternalApplicateEmptyFee);
                toastr.warning(errorMsgEmptyFee);
                return;
            }
            var thisYear = new Date().getFullYear();
            trainingInnerService.getBankBook(thisYear, sessionStorage.getItem("userLang"))
                .then(function(bankBookData) {
                    if (bankBookData) {
                        var recentPoint = parseInt(bankBookData.remainPoint) || 0;
                        var allowance = vm.applicationForm.allowance || 0;
                        //=====
                        var isPointEmpty = (recentPoint < 1);
                        if (isAllowance && isPointEmpty) {
                            //TODO:多國語系(英文)
                            var errorMsgEmptyPoint = format(
                                vm.translatePool.tsunErrorExternalApplicateAllowance,
                                (allowance + ''));
                            toastr.warning(errorMsgEmptyPoint);
                            return;
                        }
                        //=====
                        if (isAllowance) {
                            var confirmText = format(
                                vm.translatePool.tsunConfirmExternalApplicate,
                                (recentPoint + ''),
                                (allowance + ''));
                            var confirmDialog = modalService.confrimDialog({
                                confirmContent: confirmText.replace(/，/g, "<br/>"),
                            });
                            confirmDialog.result.then(function(result) {
                                result = !!result;
                                if (result !== true) {
                                    return;
                                }
                                postFormData();
                            });
                        } else {
                            postFormData();
                        }
                    }
                });
        }

        function postFormData() {
            var data = angular.copy(vm.applicationForm.dateSettingList);
            console.log('vm.applicationForm:',data);
            trainingInnerService.postExterior(vm.applicationForm).then(function(result) {
                if (result) {
                    postExteriorSuccess();
                }
            });
        }

        function postExteriorSuccess() {
            var Externaltype = trainingInnerService.getExternaltype();
            vm.form1.$submitted = false;
            vm.data.organizer = [];
            vm.data.dateSettingList = [];
            vm.applicationForm.Name = '';
            
            //修正送出第二張申請單時，type選擇錯誤
            vm.data.type=Externaltype[0];
            vm.applicationForm.type = Externaltype[0];
            
            vm.applicationForm.Outline = '';
            vm.applicationForm.Place = '';
            vm.applicationForm.coursePrice = 0;
            vm.applicationForm.travelPrice = 0;
            vm.applicationForm.totalPrice = 0;
            vm.applicationForm.allowance = 0;
            vm.applicationForm.Remark = '';
            //vm.applicationForm.currency = vm.data.currency[0];
            vm.applicationForm.organizer = [];
            vm.applicationForm.times = null;
            vm.applicationForm.dateSettingList = [];
        }

        function openOrganizer() {
            var organizerResult = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingOrganizerModal.html',
                controller: 'myTrainingOrganizerModalController as vm',
                size: 'lg',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    params: function() {
                        return vm.data.exteriorData;
                    },
                    choiceList: function() {
                        return vm.data.organizer;
                    }
                }
            });
            organizerResult.rendered.then(function() {
                var modalBootstrap = $(".modal-open > .modal");
                var modalBootstrapContent = modalBootstrap.find("> .modal-dialog > .modal-content ");
                if (!modalBootstrap) { return; }
                var footerDiv = modalBootstrap.find(".footer");
                var showDiv = modalBootstrap.find("#content");
                var buttonShowTrigger = false;
                //====
                renderInit();
                //====
                function renderInit() {
                    buttonHide();
                    adjustOrgNameWidth();
                    $(document)
                        .off('submitSearchEnd')
                        .on('submitSearchEnd', function() {
                            adjustOrgNameWidth();
                        });
                    $(document)
                        .off('submitSearchStart')
                        .on('submitSearchStart', function() {
                            buttonShowTrigger = false;
                            buttonHide();
                        });
                    $(document)
                        .off('checkboxClick')
                        .on('checkboxClick', function(event, triggerResult) {
                            // console.log("listen checkboxClick ,trigger:", triggerResult);
                            buttonShowTrigger = !!triggerResult;
                            checkboxEvent();
                        });
                    modalBootstrap.scroll(function() { scrollEvent(); });
                }

                function adjustOrgNameWidth() {
                    var allShowArea = modalBootstrapContent.find('.organizerNameShowArea');
                    allShowArea.css("max-width", (modalBootstrapContent.width() - 70) + "px");
                }

                function scrollEvent() {
                    checkButtonCanShow();
                }

                function checkboxEvent() {
                    checkButtonCanShow();
                }

                function buttonHide() {
                    if (!footerDiv) { return; }
                    footerDiv.css({ "display": "none" });
                    footerDiv.find('a,button').css({ "display": "none" });
                    $(document).trigger('floatButtonDisplay', [false]);
                }

                function checkButtonCanShow() {
                    // 改變Footer樣式，使其保持在最下面。
                    var paddingHeight = 30;
                    var checkHeight = showDiv.height() - modalBootstrap.height() - paddingHeight;
                    var buttonInContent = (checkHeight > modalBootstrap.scrollTop());
                    // console.log("showDiv:",showDiv);
                    // console.log("modalBootstrap.scrollTop()", modalBootstrap.scrollTop());
                    // console.log("checkHeight", checkHeight);
                    // console.log("buttonShowTrigger", buttonShowTrigger);
                    // console.log("buttonShowTrigger", buttonInContent);
                    if (buttonInContent && buttonShowTrigger) {
                        buttonShow();
                    } else {
                        buttonHide();
                    }
                }

                function buttonShow() {
                    if (!footerDiv) { return; }
                    footerDiv.find('a,button').css({
                        "position": "relative",
                        "display": "inline-block",
                        "left": "-50%",
                    });
                    var topLocation =
                        (modalBootstrap.height() + modalBootstrap.scrollTop()) - (footerDiv.outerHeight() * 2);
                    footerDiv.css({
                        "display": "inline-block",
                        "position": "absolute",
                        "top": topLocation,
                        "left": "50%",
                        // "right": "0px",
                        "margin-left": "auto",
                        "margin-right": "auto"
                    });
                    $(document).trigger('floatButtonDisplay', [true]);
                }
            });
            //這個則是接收傳回來的值
            organizerResult.result.then(function(data) {
                _.forEach(data, function(item) {
                    if (_.findIndex(vm.data.organizer, { "id": item.id }) < 0) {
                        vm.data.organizer.push(angular.copy(item));
                    }
                });
                vm.mustRemark = (_.findIndex(vm.data.organizer, { "id": vm.data.organizerOther }) > -1);
            });
        }

        function removeOrganizer(item) {
            var index = _.findIndex(vm.data.organizer, { "id": item.id });
            if (index < 0) { return; }

            var confirmDialog = modalService.confrimDialog({
                confirmContent: format("{0}\r\n{1}", vm.translatePool.tsunConfirmRemove, item.name),
            });
            confirmDialog.result.then(function(result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                vm.data.organizer.splice(index, 1);
            });
        }

        function openTime() {
            console.log("beforeSelect vm.data.dateSettingList", vm.data.dateSettingList);
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingExteriorTimeModal.html',
                controller: 'myTrainingExteriorTimeModalController as vm',
                size: 'lg',
                backdrop: 'static',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    saveList: function() {
                        return vm.data.dateSettingList;
                    }
                }
            });

            //這個則是接收傳回來的值
            result.result.then(function(data) {
                vm.data.dateSettingList = data;
                console.log("vm.data.dateSettingList", vm.data.dateSettingList);
            });

        }

        // function caculateDuringTime(lisTime) {
        //     var duringTimes = 0;
        //     if (lisTime) {
        //         _.forEach(lisTime, function (item) {
        //             duringTimes += item.duringTimes;
        //         });
        //     }
        //     if (!duringTimes) {
        //         duringTimes = 0;
        //     }
        //     // 將時間格式化產出
        //     return parseInt(duringTimes / 1000 / 60 / 60) + '.' + parseInt((duringTimes / 1000 / 60 % 60) * 100 / 60);
        // }

        function removeTime() {
            // var removeConfirm = confirm('確定要刪除?');
            // if (removeConfirm) {
            //     _.forEach(vm.times.selected, function (item) {
            //         var index = _.findIndex(vm.times, function (x) {
            //             return x === item;
            //         });
            //         vm.times.splice(index, 1);
            //     });
            // }
            // vm.timesCountString = caculateDuringTime(data);
        }

        function plusTotalPricer() {
            vm.applicationForm.totalPrice = vm.applicationForm.coursePrice + vm.applicationForm.travelPrice;
            if (vm.applicationForm.type) {
                var allowanceRate = vm.applicationForm.type.allowanceRate || 0;
                allowanceRate = (allowanceRate);
                vm.applicationForm.allowance = Math.round((vm.applicationForm.totalPrice * allowanceRate) / 100);
            }

        }

        function openApplicationFormTypeSelector() {
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/applicationFormTypeSelector.html',
                controller: 'applicationFormTypeSelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: modalService.getTaiClass()
            });
            //這個則是接收傳回來的值
            result.result.then(function(result) {
                vm.data.type = result;
                vm.applicationForm.type = result;
                plusTotalPricer();
            });
        }
    }
})();